<div
  #headerContainer
  class="section-header-container"
  [ngStyle]="{ 'background-image': headerBackgroundAsset$ | async }"
  [style.background-color]="
    (menu | productMenuBasicMethod: 'getShowSectionHeaderColorAsIcon')
      ? null
      : section?.metadata?.productsHeaderBackgroundColor
  "
  [style.background-size]="'cover'"
  [style.border-bottom-color]="menu | productMenuBasicMethod: 'getSectionTitleUnderlineColor' : section"
  [style.border-color]="menu | productMenuBasicMethod: 'getSectionTitleBorderColor' : section"
  [style.zoom]="menu?.menuOptions?.productZoom || 1.0"
  [class.section-header-bottom-border]="menu | productMenuBasicMethod: 'getSectionHeaderUnderlined'">
  <ng-container *ngFor="let colVm of columnVMs; trackBy: trackByColumnViewModelId">
    <app-header-column-wrapper
      [calculationMode]="calculationMode"
      [menu]="menu"
      [section]="section"
      [colVm]="colVm"
      [sectionRowViewModels]="sectionRowViewModels">
      <!-- most likely hits closer to top of else if structure -->
      @if (colVm?.columnType === Types.SectionColumnProductInfoType.ProductTitle) {
        <app-header-column-product-title [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.VariantPrice) {
        <app-header-column-variant-price [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.VariantSecondaryPrice) {
        <app-header-column-variant-secondary-price [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Badge) {
        <app-header-column-badge [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Brand) {
        <app-header-column-brand [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Label) {
        <app-header-column-label [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.VariantType) {
        <app-header-column-variant-type [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Stock) {
        <app-header-column-quantity-in-stock [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.QuantityAndSize) {
        <app-header-column-quantity-and-size [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Quantity) {
        <app-header-column-quantity [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Size) {
        <app-header-column-size [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.StrainType) {
        <app-header-column-strain-type [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Strain) {
        <app-header-column-strain [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType | isCannabinoidColumn) {
        <app-header-column-cannabinoid
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [sectionRowViewModels]="sectionRowViewModels"
          [cannabinoidColumnType]="colVm?.columnType | isCannabinoidColumn" />
      } @else if (colVm?.columnType | isTerpeneColumn) {
        <app-header-column-terpene
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [sectionRowViewModels]="sectionRowViewModels"
          [terpeneColumnType]="colVm?.columnType | isTerpeneColumn" />
      } @else if (colVm?.columnType | isProductTagGroupColumn) {
        <app-header-column-product-tag-group
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [productTagGroupColumnType]="colVm?.columnType | isProductTagGroupColumn" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Lineage) {
        <app-header-column-lineage [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Asset) {
        <app-header-column-asset [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Producer) {
        <app-header-column-producer [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.HelpsWith) {
        <app-header-column-helps-with [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Effects) {
        <app-header-column-effects [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Aroma) {
        <app-header-column-aroma [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.GrowingConditions) {
        <app-header-column-growing-conditions [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.CraftDesignation) {
        <app-header-column-craft-designation [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.CraftDesignation) {
        <app-header-column-craft-designation [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Appearance) {
        <app-header-column-appearance [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Flavor) {
        <app-header-column-flavor [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.TopFlavor) {
        <app-header-column-top-flavor [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.EnergyScore) {
        <app-header-column-energy-score [menu]="menu" [section]="section" [colVm]="colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.GradingResults) {
        <app-header-column-grading-results-score [menu]="menu" [section]="section" [colVm]="colVm" />
      }
    </app-header-column-wrapper>
  </ng-container>
</div>
